export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('sys_quartz_task_quartzTaskStatus') || '任务状态',
    field: 'quartzTaskStatus',
    width: 120,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('sys_quartz_task_quartzTaskStartTime') || '开始时间',
    field: 'quartzTaskStartTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('sys_quartz_task_quartzTaskStopTime') || '结束时间',
    field: 'quartzTaskStopTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_quartzTaskResult') || '任务执行结果',
    field: 'quartzTaskResult',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
